import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import { compose } from 'redux';
import { withConditionalFeatures } from '@americanexpress/conditional-features';
import ImageSlider from '../ImageSlider/ImageSlider';
import SideCollapsible from '../SideCollapsible/SideCollapsible';
import { getShowTravelCreditTab } from '../../selectors/getHomeSelectors';
import TravelCreditTab from '../TravelCreditTab/TravelCreditTab';
import { hasTravelCreditTabRule } from '../../constants/featureRulesConstants';
import style from '../CardOffersContainer/CardOffers.scss';
import { getSelectedAccount } from '../../utils/travelerDataUtils';
import { useTopCardAccount } from '../../hooks/useTBSBenefits';
import { useTravelerData } from '../../hooks/useTravelerData';

const LargeTile = ({
  showTravelBenefits,
  carousel,
  hasTravelCreditTab,
}) => {
  const { travelerData } = useTravelerData();
  const { topCardAccount } = useTopCardAccount();
  const selectedAccountData = getSelectedAccount(
    travelerData,
    topCardAccount?.loyaltyAccountNumber
  );
  const showTravelCreditTab = useSelector(getShowTravelCreditTab);
  const travelCreditData = selectedAccountData?.travelCredit;
  const hasTravelCredit = hasTravelCreditTab && travelCreditData
    && Object.keys(travelCreditData).length > 0;

  return (
    <div className={clsx('position-relative fluid', !!hasTravelCredit && style.minHeight)}>
      <div className={clsx(showTravelBenefits && 'pad-2-lr-sm-down pad-1-l-md-up pad-2-l-lg-up')}>
        <ImageSlider offers={carousel} />
      </div>
      {!!hasTravelCredit && (
        <SideCollapsible
          hasTravelCredit={!!hasTravelCredit}
          isOpen={showTravelCreditTab}
          labelledBy="showTravelCreditTabButton"
        >
          <TravelCreditTab selectedAccountData={selectedAccountData} />
        </SideCollapsible>
      )}
    </div>
  );
};

LargeTile.propTypes = {
  showTravelBenefits: PropTypes.bool,
  carousel: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  selectedAccountData: PropTypes.shape({
    travelCredit: PropTypes.shape({}),
  }).isRequired,
  hasTravelCreditTab: PropTypes.bool.isRequired,
};

LargeTile.defaultProps = {
  showTravelBenefits: false,
};

export { LargeTile as TestableLargeTile };

export const mapFeaturesToProps = {
  hasTravelCreditTab: hasTravelCreditTabRule,
};

const hocChain = compose(
  withConditionalFeatures({ mapFeaturesToProps })
);

export default hocChain(LargeTile);
